import * as React from 'react';
import TimelineCircleImage from '../../../../timeline/TimelineCircleImage/TimelineCircleImage';

const Image = require('../../../../../assets/img/timeline/modal/1992-sac.jpg');

const SacContent = () => {
    return (
        <>
            <TimelineCircleImage image={Image} />
            <h4>
                Scientific Advisory Committee
            </h4>
            <p>
            The Scientific Advisory Committee (SAC) is established and is responsible for setting our research agenda. SAC develops, evaluates and recommends new clinical trial proposals to the Board and assigns priority; reviews potential new trial questions, current practices and patient groups to determine gaps and opportunities for future clinical trials; and monitors our current and ongoing clinical trials. Professor Alan Coates AM was the first Chair of SAC. 
            </p>
        </>
    );
}

export default SacContent;